export const BRAND = {
  name: "Nguvu Ya Mwanamke Foundation",
  short: "Nguvu Ya Mwanamke",
  tagline: "Empowering Mothers. Strengthening Families. Transforming Lives.",
  subTagline: "Empowering Women & Children. Changing Lives.",
  mission:
    "We empower single mothers and support families raising children with disabilities through education, advocacy, mental-health support, economic opportunities and community-based services.",
  logo: "https://customer-assets.emergentagent.com/job_mwanamke-support/artifacts/spfahq4h_fa8b660e-d44c-461e-96ee-5be1961f8365.jpeg",
  logoIcon: "/api/static/logo-icon.png",
  email: "nymfoundationorg@gmail.com",
  phone: "+255 740 588 878",
  address: "Dar es Salaam, Tanzania",
  socials: {
    instagram: "https://www.instagram.com/nymfoundation",
    facebook: "https://facebook.com/",
    linkedin: "https://linkedin.com/",
    twitter: "https://x.com/",
  },
  donateUrl: "#donate",
};

export const NAV = [
  { label: "About", href: "#about", type: "anchor" },
  { label: "Programs", href: "#programs", type: "anchor" },
  { label: "Stories", href: "/stories", type: "route" },
  { label: "Team", href: "/team", type: "route" },
  { label: "Need Support", href: "#need-support", type: "anchor" },
  { label: "Get Involved", href: "#get-involved", type: "anchor" },
  { label: "Contact", href: "#contact", type: "anchor" },
];

export const PROGRAMS = [
  {
    slug: "maternal-wellbeing",
    title: "Maternal Wellbeing",
    short: "Mental health & peer networks",
    summary:
      "Healing-centered support for mothers navigating postpartum depression, grief and isolation — with peer circles and professional referrals.",
    icon: "Heart",
    image:
      "https://images.pexels.com/photos/27499880/pexels-photo-27499880.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bullets: [
      "Postpartum depression support",
      "Peer-led healing circles",
      "Therapist & counselor referrals",
    ],
  },
  {
    slug: "children-disabilities",
    title: "Children with Disabilities",
    short: "Advocacy & access",
    summary:
      "We walk alongside families raising children with disabilities — from therapy access to fighting stigma in schools and communities.",
    icon: "Accessibility",
    image:
      "https://images.unsplash.com/photo-1741940365437-e55b919a89d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwbW90aGVyJTIwY2hpbGQlMjB3YXJtJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgyMTk4MzE0fDA&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Inclusion advocacy",
      "Therapy & assistive resources",
      "Community awareness campaigns",
    ],
  },
  {
    slug: "education",
    title: "Education",
    short: "Return-to-school & scholarships",
    summary:
      "Scholarships, school re-entry coaching and skills training that put mothers back in classrooms — and futures back in their hands.",
    icon: "GraduationCap",
    image:
      "https://images.pexels.com/photos/5386422/pexels-photo-5386422.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bullets: [
      "Re-entry to school programs",
      "Scholarships & bursaries",
      "Vocational skill development",
    ],
  },
  {
    slug: "economic-empowerment",
    title: "Economic Empowerment",
    short: "Grants & livelihoods",
    summary:
      "Seed grants, entrepreneurship training and employment links that turn talent into income and survival into stability.",
    icon: "Briefcase",
    image:
      "https://images.unsplash.com/photo-1573164574397-dd250bc8a598?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxhZnJpY2FuJTIwd29tZW4lMjB3b3JraW5nJTIwdG9nZXRoZXJ8ZW58MHx8fHwxNzgyMTk4MzE0fDA&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Micro-grants & business kits",
      "Entrepreneurship bootcamps",
      "Employment referrals",
    ],
  },
  {
    slug: "community-support",
    title: "Community Support",
    short: "Mentorship & networks",
    summary:
      "Mothers are not meant to do this alone. We build trusted networks, mentor matches and resource navigation for whole-family flourishing.",
    icon: "Users",
    image:
      "https://images.unsplash.com/photo-1573165706511-3ffde6ef1fe3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwd29tZW4lMjB3b3JraW5nJTIwdG9nZXRoZXJ8ZW58MHx8fHwxNzgyMTk4MzE0fDA&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Single-mother support groups",
      "1:1 mentorship matches",
      "Resource & referral hub",
    ],
  },
  {
    slug: "health-wellbeing",
    title: "Health & Wellbeing",
    short: "Maternal & family health",
    summary:
      "Health education, maternal-care outreach and family-wellbeing initiatives that center mothers as the heart of the household.",
    icon: "HeartPulse",
    image:
      "https://images.unsplash.com/photo-1504888060547-83cbe78ccfe0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwbW90aGVyJTIwY2hpbGQlMjB3YXJtJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgyMTk4MzE0fDA&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Maternal health outreach",
      "Health & nutrition education",
      "Family-wellbeing initiatives",
    ],
  },
];

export const HERO_IMAGE =
  "https://images.pexels.com/photos/37249314/pexels-photo-37249314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1741940365437-e55b919a89d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwbW90aGVyJTIwY2hpbGQlMjB3YXJtJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgyMTk4MzE0fDA&ixlib=rb-4.1.0&q=85";
